import moment from 'moment';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { Input, Textarea } from 'rizzui';
import useFetch from '../../../../../hooks/useFetch';
import { LeadsService } from '../../../../../services/leads/leadsService';
import { Lead } from '../../../../../type/entities/leads-type';
import { renewalSettingsOptions } from '../../../../settings/product-types/ProductTypeModalForm';
import LeadProfileLayout from '../../LeadProfileLayout';

export default function LeadInfo() {
    const { id = '' } = useParams<{ id: string }>();

    const [data, isLoading] = useFetch(useCallback(async () => {
        if (!id || id === '') return null;
        const response = await (new LeadsService()).getLead(id);
        return response.getResponseData() as Lead;
    }, [id]));

    return (
        <LeadProfileLayout isLoading={isLoading}>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 pt-6">
                <Input
                    label='Contrato de origen'
                    value={data?.originalContract?.code || ''}
                    readOnly
                />

                <Input
                    label='Tipo de producto'
                    value={data?.productTypes?.name || ''}
                    readOnly
                />

                <Input
                    label='Cliente'
                    value={data?.client?.companyName || ''}
                    readOnly
                />

                <Input
                    label='Producto'
                    value={data?.product?.name || ''}
                    readOnly
                />

                <Input
                    label='Origen'
                    value={data?.origin === 'auto_renovation' ? 'Renovación Automática' : 'Renovación Manual'}
                    readOnly
                />

                <Input
                    label='Agente'
                    value={`${data?.user?.name} ${data?.user?.lastName || ''}` || ''}
                    readOnly
                />

                <Input
                    label='Red comercial'
                    value={data?.commercialNetwork?.name || ''}
                    readOnly
                />

                <Input
                    label='Configuración de renovación'
                    value={renewalSettingsOptions.find(option => option.value === (data?.productTypes?.renewalSettings || data?.product?.renewalSettings))?.label || 'N/A'}
                    readOnly
                />

                <Input
                    label='Fecha objetivo'
                    value={data?.targetDate ? moment(data.targetDate?.date).format('DD/MM/YYYY') : ''}
                    readOnly
                />

                <Input
                    label='Contrato generado'
                    value={data?.generatedContract || ''}
                    readOnly
                />

                {data?.lastLeadKoReason && (
                    <>
                        <Input
                            readOnly
                            id='lastLeadKoReasonName'
                            label="Motivo de KO"
                            value={data.lastLeadKoReason.name}
                        />
                        <Textarea
                            readOnly
                            id='lastLeadKoReasonDescription'
                            label="Descripción del motivo de KO"
                            value={data.lastLeadKoReason.description ?? ''}
                            rows={4}
                        />
                    </>
                )}
            </div>
        </LeadProfileLayout>
    );
}